import { useLocaleStore } from '@/stores/Locale.store'
import type { Composer } from 'vue-i18n'
import lvDayjs from '@/utils/dayjs/locales/lv'
import enDayjs from '@/utils/dayjs/locales/en'
import deDayjs from '@/utils/dayjs/locales/de'
import ruDayjs from '@/utils/dayjs/locales/ru'
import etDayjs from '@/utils/dayjs/locales/et'
import ltDayjs from '@/utils/dayjs/locales/lt'
import fiDayjs from '@/utils/dayjs/locales/fi'
import ukDayjs from '@/utils/dayjs/locales/uk'

export default defineNuxtPlugin((nuxtApp) => {
  const i18n = nuxtApp.$i18n as Composer
  const locale = i18n.locale.value || 'en'

  const localeStore = useLocaleStore()
  localeStore.initCookies()
  localeStore.setSelectedLanguage(locale)

  const dayjs = useDayjs()

  dayjs.updateLocale('de', { ...deDayjs })
  dayjs.updateLocale('lv', { ...lvDayjs })
  dayjs.updateLocale('en', { ...enDayjs })
  dayjs.updateLocale('ru', { ...ruDayjs })
  dayjs.updateLocale('et', { ...etDayjs })
  dayjs.updateLocale('lt', { ...ltDayjs })
  dayjs.updateLocale('fi', { ...fiDayjs })
  dayjs.updateLocale('uk', { ...ukDayjs })
  dayjs.locale(locale)
})
